/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material/styles";
import { Dialog, DialogContent, Box, IconButton, Typography } from "@mui/material";

export const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    borderRadius: "16px",
    width: "560px",
    maxWidth: "92vw",
    padding: "8px",
  },
});

export const StyledModalHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "12px 16px 0px 16px",
});

export const StyledModalTitle = styled(Typography)({
  flex: 1,
  textAlign: "center",
  fontSize: "22px",
  fontWeight: 700,
  color: "#1a2b4a",
});

export const StyledCloseButton = styled(IconButton)({
  color: "#515152",
});

export const StyledModalContent = styled(DialogContent)({
  paddingTop: "16px",
  maxHeight: "70vh",
  overflowY: "auto",
});

export const StyledFieldContainer = styled(Box)({
  marginTop: "16px",
});

export const StyledPhoneRow = styled(Box)({
  display: "flex",
  gap: "5px",
});

export const StyledModalActions = styled(Box)({
  display: "flex",
  justifyContent: "center",
  gap: "16px",
  padding: "12px 24px 20px 24px",
});
